var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.itemCount),function(n){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.index === (n - 1)),expression:"index === (n - 1)"}]},[_vm._t(`item${n - 1}`)],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }